import { render } from "./AboutBlock.vue?vue&type=template&id=36ed13a1"
import script from "./AboutBlock.vue?vue&type=script&lang=js"
export * from "./AboutBlock.vue?vue&type=script&lang=js"

import "./AboutBlock.vue?vue&type=style&index=0&id=36ed13a1&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__